<script>
    import { createEventDispatcher } from 'svelte'
    import BigIcon from '../../components/Icons/BigIcon.svelte'
    import SearchQuery from '../../components/SearchQuery/SearchQuery.svelte'
    import SidepanelButton from '../../components/SidepanelLink/SidepanelButton.svelte'
    // import MonthSelector from '../../components/PeriodSelector/MonthSelector.svelte'
    // import SidepanelSelect from '../../components/SidepanelFields/SidepanelSelect.svelte'

    export let data 
    
    const dispatch = createEventDispatcher ();

</script>

<style>
    .SidepanelContent {
        padding: 25px 20px 20px 20px;
    }
    .SidepanelContent .icon-holder {
        text-align: center;
        margin-bottom: 10px;
    }
    .SidepanelContent .meta {
        text-align: center;
        margin-bottom: 20px;
    }
    .SidepanelContent .meta .label {
        font-size: 18px;
        font-weight: 600;
    }
    .SidepanelContent .meta .text {
        font-size: 13px;
        color: var(--text-secondary);
        line-height: 14px;
    }
    .SidepanelContent .time-range {
        margin-top: 10px;
    }
    .SidepanelContent .query-type {
        margin-top: 10px;
    }
    .SidepanelContent .ctrls {
        margin-top: 10px;
    }
    .SidepanelContent .ctrls button {
        width: 100%;
    }
</style>

<div class="SidepanelContent">
    <div class="icon-holder">
        <BigIcon icon="fad fa-bell-on"  />
    </div>
    <div class="meta">
        <div class="label">Alerts</div>
        <div class="text">Regole periodiche alerts</div>
    </div>
    <div class="links">
        <SidepanelButton on:click={e => dispatch ('create')} >
            Crea nuova regola
        </SidepanelButton>
    </div>
    <div class="search">
        <SearchQuery on:search />
    </div>
</div>